import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { Button, DatePicker } from 'antd';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

const FirstSeenDatePickerFilter = ({
  filters,
  onSubmit,
  onReset,
  confirm,
  status,
}) => {
  const [value, setValue] = useState(
    filters.first_seen_from
      ? [
          moment(filters.first_seen_from).tz('UTC'),
          moment(filters.first_seen_to).tz('UTC'),
        ]
      : [],
  );

  useEffect(() => {
    setValue(
      filters.first_seen_from
        ? [
            moment(filters.first_seen_from).tz('UTC'),
            moment(filters.first_seen_to).tz('UTC'),
          ]
        : [],
    );
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (value) => {
    setValue(value);
  };

  const handleReset = () => {
    confirm();
    setValue([]);
    onReset();
  };

  const handleSubmit = () => {
    confirm();
    onSubmit(value);
    incrementUIRequestsCounter();
  };

  return (
    <div style={{ padding: 8 }}>
      <DatePicker.RangePicker
        onKeyDown={(e) => e.stopPropagation()}
        onChange={handleChange}
        value={value}
        style={{ marginBottom: 8 }}
        placeholder={['Start Date', 'End Date']}
      />
      <div>
        <Button
          type="primary"
          role="search"
          onClick={handleSubmit}
          style={{}}
          //icon={<SearchOutlined />}
          size="small"
        >
          Search
        </Button>
        <Button
          role="reset"
          style={{
            border: 'none',
            marginLeft: '2%',
            background: '#213338',
            color: '#b1c4d0',
          }}
          onClick={handleReset}
          size="small"
        >
          Clear
        </Button>
      </div>
    </div>
  );
};

export default FirstSeenDatePickerFilter;
